const React = window.React || null;

const MainMenu = React.memo(function MainMenu(){

    if( window?.adw && window.adw.nav_main?.items?.length === 0 ) return null;

    return (
        <ul className="main-menu d-flex flex-column flex-grow-1 justify-content-center align-items-start gap-3 px-0 mb-0">
            { window.adw.nav_main.items.map( (item, index) => {
                return (
                    <li className="list-unstyled lh-1 "
                        key={`main-menu-item-${index}`}
                    >
                       <LinkItem item={item} index={index}/>
                    </li>
                )
            })
            }
        </ul>
    );
});

const LinkItem = ({item, index}: {item: any, index: number}) => {

    const ref = React.useRef<HTMLAnchorElement>(null);

    return(
        <a key={index}
            ref={ref}

            className="font-pre-heading text-hover-primary h2 lh-1 mb-0 text-decoration-none text-uppercase d-inline-block"
            href={item.url}
        >

            {item.title}
        </a>
    )
}

export default MainMenu;